export default __webpack_public_path__ + "static/media/Wallet.fe4f2318.svg";